<template>
  <div id="header">
    <v-dialog v-model="invite.modal" width="1000">
      <v-card class="rounded-xl" elevation="7">
        <v-container>
          <v-card-title class="text-center">
            <h2 class="text-h5">Invite a Friend</h2>
          </v-card-title>
          <v-card-text>
            Enter your friends email, your invite will be sent to them after
            Troplo, or another TPU administrator approves it.
            <v-text-field
              v-model="invite.email"
              label="Email"
              type="email"
              required
              placeholder="troplo@troplo.com"
              autofocus
              @keyup.enter="inviteFriend"
            ></v-text-field>
            <small>
              You can make a max of 1 invite per day.<br />You will receive an
              email when your request is accepted or denied.<br /><strong
                >Invite a Friend ends on 1/1/2023.</strong
              ><br />Your friend will not use Flowinity SSO to authenticate.
            </small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              class="rounded-xl"
              :disabled="!invite.email.length"
              @click="inviteFriend"
              >Invite</v-btn
            >
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="switcher.dialog" max-width="600px">
      <v-card color="card">
        <v-toolbar color="toolbar">
          <v-toolbar-title>
            {{ $store.state.site.name }} QuickSwitcher
          </v-toolbar-title>
        </v-toolbar>
        <v-container v-if="switcher.dialog">
          <v-autocomplete
            @keydown.enter="handleEnter"
            auto-select-first
            v-model="switcher.search"
            :items="$store.state.quickSwitchCache"
            item-text="name"
            label="Search"
            outlined
            autofocus
            return-object
            :search-input.sync="switcher.searchInput"
          >
          </v-autocomplete>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="shortcuts" width="700">
      <v-card color="card" elevation="7">
        <v-toolbar color="toolbar">
          <v-toolbar-title> Shortcuts </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-layout row wrap>
              <v-card class="mx-2 mt-2">
                <v-card-title> QuickSwitcher </v-card-title>
                <v-card-text class="text-center">
                  <v-btn text outlined> CTRL </v-btn>
                  <v-btn text outlined class="ml-2"> K </v-btn>
                </v-card-text>
              </v-card>
              <v-card class="mx-2 mt-2">
                <v-card-title> RouteSwitcher </v-card-title>
                <v-card-text class="text-center">
                  <v-btn text outlined> CTRL </v-btn>
                  <v-btn text outlined class="ml-2"> B </v-btn>
                </v-card-text>
              </v-card>
              <v-card class="mx-2 mt-2">
                <v-card-title> Shortcuts </v-card-title>
                <v-card-text class="text-center">
                  <v-btn text outlined class="ml-2"> CTRL </v-btn>
                  <v-btn text outlined class="ml-2"> / </v-btn>
                </v-card-text>
              </v-card>
              <!--<v-card class="mx-2 mt-2">
                <v-card-title> Toggle CSS </v-card-title>
                <v-card-text class="text-center">
                  <v-btn text outlined> F9 </v-btn>
                  <span class="ml-2">or</span>
                  <v-btn text outlined class="ml-2"> CTRL </v-btn>
                  <v-btn text outlined class="ml-2"> ALT </v-btn>
                  <v-btn text outlined class="ml-2"> D </v-btn>
                </v-card-text>
              </v-card>-->
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="route.modal" width="700">
      <v-card color="card" elevation="7">
        <v-toolbar color="toolbar">
          <v-toolbar-title> Go to Route </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-text-field
              class="rounded-xl"
              v-model="route.value"
              autofocus
              @keyup.enter="goToRoute()"
              label="Route"
              required
            ></v-text-field>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="rounded-xl" text @click="route.modal = false">
            Close
          </v-btn>
          <v-btn
            class="rounded-xl"
            color="blue darken-1"
            text
            @click="goToRoute()"
          >
            Go
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="feedback.modal" width="700">
      <v-card class="rounded-xl" elevation="7">
        <v-card-title>
          <span class="text-h5">Provide Feedback</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="4" sm="6">
                <v-text-field
                  class="rounded-xl"
                  v-model="feedback.route"
                  label="Route"
                  required
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" sm="6">
                Rating:
                <v-rating
                  v-model="feedback.rating"
                  background-color="grey darken-1"
                  color="yellow darken-3"
                  empty-icon="$ratingFull"
                  hover
                ></v-rating>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  class="rounded-xl"
                  v-model="feedback.text"
                  label="Enter your Feedback"
                  required
                ></v-textarea>
              </v-col>
              <small
                >Your feedback will be used to make
                {{ $store.state.site.name }} better.</small
              >
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="rounded-xl"
            color="blue darken-1"
            text
            @click="feedback.modal = false"
          >
            Close
          </v-btn>
          <v-btn
            class="rounded-xl"
            color="blue darken-1"
            text
            @click="submitFeedback()"
          >
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-app-bar
      v-if="
        (this.$route.name !== 'Bio' && $store.state.user.username) ||
        (!$store.state.user.username &&
          this.$route.name !== 'Dashboard' &&
          this.$route.name !== 'Register' &&
          this.$route.name !== 'Bio')
      "
      app
      color="dark"
    >
      <button
        style="display: none"
        v-shortkey="['ctrl', 'k']"
        @shortkey="switcher.dialog = true"
      >
        Debug
      </button>
      <button
        style="display: none"
        v-shortkey="['meta', 'k']"
        @shortkey="switcher.dialog = true"
      >
        Debug
      </button>
      <button
        style="display: none"
        v-shortkey="['ctrl', 'b']"
        @shortkey="route.modal = true"
      >
        Debug
      </button>
      <button
        style="display: none"
        v-shortkey="['ctrl', '/']"
        @shortkey="shortcuts = true"
      >
        Debug
      </button>
      <v-app-bar-nav-icon
        style="z-index: 1000"
        @click.stop="drawer = !drawer"
        v-if="$vuetify.breakpoint.mdAndDown"
      ></v-app-bar-nav-icon>
      <v-img
        style="z-index: 10; cursor: pointer"
        @click="$router.push('/')"
        src="../assets/logo.svg"
        max-height="40px"
        max-width="130px"
        v-if="!$store.state.site.whitelabel"
      ></v-img>
      <h1
        style="z-index: 10; cursor: pointer"
        class="text-gradient-alt"
        v-if="$store.state.site.whitelabel"
        @click="$router.push('/dashboard')"
      >
        {{ $store.state.site.name }}
      </h1>
      <v-app-bar-nav-icon
        style="z-index: 1000"
        v-if="$store.state.site.release !== 'prod'"
        disabled
        >{{ $store.state.site.release }}</v-app-bar-nav-icon
      >
      <v-row class="center-nav">
        <v-col cols="12">
          <v-list
            v-if="
              !$vuetify.breakpoint.mdAndDown &&
              $store.state.navigation === 'navbar'
            "
          >
            <v-btn
              text
              v-for="(item, index) in eligibleMenus"
              :key="item.id"
              @click="handleClick(index)"
              class="ml-1 rounded-xl"
              rounded
              :to="item.path"
              :color="active(item.name)"
              style="text-transform: unset !important"
              :disabled="item.disabled"
            >
              <v-icon>{{ item.icon }}</v-icon
              >&nbsp;
              <v-list-item-title
                >{{ item.name
                }}<template v-if="item.preview"
                  >&nbsp;</template
                ></v-list-item-title
              >
              <v-btn
                class="rounded-xl"
                rounded
                outlined
                color="success"
                x-small
                v-if="item.preview"
              >
                <v-icon style="font-size: 15px">mdi-flask</v-icon>
              </v-btn>
            </v-btn>
          </v-list>
        </v-col>
      </v-row>
      <span
        v-if="
          $store.state.site.release === 'dev' &&
          $store.state.site.devNotification
        "
        >Dev Notification: {{ $store.state.site.devNotification }}</span
      >
      <v-spacer></v-spacer>
      <v-menu
        v-if="$store.state.user.username"
        offset-y
        rounded
        class="rounded-xxl"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="rounded-xl" icon v-bind="attrs" v-on="on">
            <v-avatar
              v-if="!$store.state.user.avatar"
              align="center"
              class="text-center"
              size="38"
            >
              <v-img
                :src="
                  '/api/v1/userutils/identicon/' + $store.state.user.username
                "
              ></v-img>
            </v-avatar>
            <v-avatar
              v-if="$store.state.user.avatar"
              align="center"
              class="text-center"
              size="38"
            >
              <v-img :src="'/i/' + $store.state.user.avatar"></v-img>
            </v-avatar>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            v-for="(item, index) in menus.dropdownAuthenticated"
            :key="item.id"
            :disabled="item.disabled"
            :to="item.path"
            @click="handleClickDropdown(index)"
          >
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item>
          <template v-if="$store.state.user.admin">
            <v-list-item
              v-for="(item, index) in menus.admin"
              :key="item.id"
              :disabled="item.disabled"
              :to="item.path"
              @click="handleClickDropdown(index)"
            >
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item>
          </template>
          <template
            v-if="$store.state.user.moderator || $store.state.user.admin"
          >
            <v-list-item
              v-for="(item, index) in menus.moderator"
              :key="item.id"
              :disabled="item.disabled"
              :to="item.path"
              @click="handleClickDropdown(index)"
            >
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item>
          </template>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-navigation-drawer
      v-if="
        ($route.name !== 'Bio' &&
          $store.state.user.username &&
          $store.state.navigation === 'sidebar') ||
        $vuetify.breakpoint.mdAndDown ||
        ($store.state.navigation === 'sidebar' && $store.state.user.username)
      "
      v-model="drawer"
      app
      color="dark"
      expand
      floating
    >
      <v-divider></v-divider>
      <v-list dense nav>
        <v-list v-if="$store.state.user.username">
          <v-list>
            <template>
              <v-list-item
                class="ml-1"
                style="text-transform: unset !important"
                text
                v-for="(item, index) in menus.authenticated"
                :key="item.id"
                :href="item.externalPath"
                :to="item.path"
                link
                :color="active(item.name)"
                @click="handleClick(index)"
                :class="{ outlined: item.gold }"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }} </v-icon>
                </v-list-item-icon>

                <v-list-item-content class="pb-n2">
                  <v-list-item-title
                    >{{ item.name }}
                    <v-chip
                      class="pb-n2 ml-1"
                      v-if="item.new && !item.warning"
                      color="green"
                      outlined
                      x-small
                    >
                      NEW
                    </v-chip>
                    <v-chip
                      class="pb-n2 ml-1"
                      v-if="item.warning"
                      outlined
                      x-small
                    >
                      {{ item.warning }}
                    </v-chip>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-if="!$store.state.site.whitelabel">
              <v-list-item
                class="ml-1"
                v-for="(item, index) in menus.brand"
                :key="item.id"
                :href="item.externalPath"
                :to="item.path"
                link
                @click="handleClick(index)"
              >
                <v-list-item-icon>
                  <v-icon
                    v-bind:class="{
                      gradient:
                        item.name === $route.name &&
                        !$store.state.site.whitelabel
                    }"
                    >{{ item.icon }}
                  </v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-if="$store.state.site.release === 'dev'">
              <v-list-item
                class="ml-1"
                v-for="(item, index) in menus.debug"
                :key="item.id"
                :to="item.path"
                link
                @click="handleClick(index)"
              >
                <v-list-item-icon>
                  <v-icon
                    v-bind:class="{
                      gradient:
                        item.name === $route.name &&
                        !$store.state.site.whitelabel
                    }"
                    >{{ item.icon }}
                  </v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title
                    >{{ item.name }}
                    <v-chip
                      v-if="item.preview"
                      class="ma-2"
                      color="success"
                      outlined
                      rounded
                      x-small
                    >
                      <v-icon>mdi-flask</v-icon>
                    </v-chip>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-if="$store.state.user.admin">
              <v-list-item
                class="ml-1"
                v-for="(item, index) in menus.admin"
                :key="item.id"
                :to="item.path"
                link
                @click="handleClick(index)"
              >
                <v-list-item-icon>
                  <v-icon
                    v-bind:class="{
                      gradient:
                        item.name === $route.name &&
                        !$store.state.site.whitelabel
                    }"
                    >{{ item.icon }}
                  </v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template
              v-if="$store.state.user.admin || $store.state.user.moderator"
            >
              <v-list-item
                class="ml-1"
                v-for="(item, index) in menus.moderator"
                :key="item.id"
                :to="item.path"
                link
                @click="handleClick(index)"
              >
                <v-list-item-icon>
                  <v-icon
                    v-bind:class="{
                      gradient:
                        item.name === $route.name &&
                        !$store.state.site.whitelabel
                    }"
                    >{{ item.icon }}
                  </v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
          <template v-slot:append>
            <div class="pa-2">
              <v-btn class="rounded-xl" block> Logout</v-btn>
            </div>
          </template>
        </v-list>
        <v-list v-else>
          <v-list-item two-line>
            <v-list-item-avatar>
              <v-icon x-large>mdi-account-circle</v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>Please login</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list>
            <v-list-item
              v-for="(item, index) in menus.default"
              :key="index"
              :to="item.path"
              link
              @click="handleClick(index)"
            >
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-list>
      </v-list>
      <template v-slot:append v-if="$store.state.user.username">
        <div class="pa-2">
          <v-progress-linear
            :color="calculateColorQuota"
            :value="calculateQuota"
            height="25"
            rounded
          >
            {{ Math.ceil(calculateQuota) }}% ({{
              fileSize($store.state.user.quota)
            }}/{{ fileSize($store.state.user.plan.quotaMax) }})
          </v-progress-linear>
        </div>
      </template>
    </v-navigation-drawer>
    <v-container v-if="$store.state.user.banned">
      <v-alert color="error darken-1" type="error">
        You have been banned from {{ $store.state.site.name }}, please contact
        support.<br />Your account will have limited features while its in a
        banned state.
      </v-alert>
    </v-container>
    <v-alert
      type="info"
      style="width: 100%; border-radius: 0; z-index: 4; cursor: pointer"
      class="mb-n1"
      text
      icon="mdi-gift-outline"
      dismissible
      @click="invite.modal = true"
      v-if="$store.state.user.username && $store.state.user.invitesV2Visible"
    >
      You can now invite a friend to TPU! Click to learn more.
      <template v-slot:close>
        <v-btn icon x-small @click.stop="dismissPromoInvite">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-alert>
  </div>
</template>
<script>
import AjaxErrorHandler from "@/lib/errorHandler"
import dayjs from "dayjs"
const advancedFormat = require("dayjs/plugin/advancedFormat")
dayjs.extend(advancedFormat)

export default {
  name: "Header",
  data: () => ({
    shortcuts: false,
    route: {
      modal: false,
      value: ""
    },
    pulse: {
      timeOnPage: 0,
      timeOnPageGlobal: 0,
      interval: null,
      id: "",
      lastCreated: ""
    },
    switcher: {
      search: null,
      searchInput: null,
      dialog: false
    },
    feedback: {
      modal: false,
      route: "",
      text: "",
      rating: 0
    },
    invite: {
      keys: [],
      count: 0,
      email: "",
      activeCount: 0,
      expiry: "",
      modal: false,
      headers: [
        { text: "Invite Key", value: "inviteKey" },
        { text: "Expired", value: "active" },
        { text: "Used By", value: "invitedUser.username" },
        { text: "Created at", value: "createdAt" },
        { text: "Expiry", value: "expiredAt" },
        { text: "Options", value: "options" }
      ]
    },
    drawer: true,
    menus: {
      selected: 1,
      authenticated: [
        { id: 1, click() {}, path: "/", name: "Dashboard", icon: "mdi-home" },
        {
          id: 2,
          click() {},
          path: "/settings",
          name: "Settings",
          icon: "mdi-account-cog"
        },
        {
          id: 3,
          click() {},
          path: "/domains",
          name: "Domains",
          icon: "mdi-web"
        },
        {
          id: 4,
          click() {},
          path: "/users",
          name: "Users",
          icon: "mdi-account-group"
        },
        { id: 5, click() {}, path: "/tools", name: "Tools", icon: "mdi-cog" },
        {
          id: 6,
          click() {},
          path: "/gallery",
          name: "Gallery",
          icon: "mdi-image-multiple"
        },
        {
          id: 7,
          click() {},
          path: "/settings/subscriptions",
          name: "Subscriptions & Billing",
          icon: "mdi-plus"
        },
        {
          id: 8,
          click() {
            this.darkMode()
          },
          path: "",
          name: "Toggle Theme (temp)",
          icon: "mdi-image"
        },
        {
          id: 9,
          click() {
            this.inviteUser()
          },
          path: "",
          name: "Redeem an Invite ()",
          icon: "mdi-plus"
        }
      ],
      debug: [],
      admin: [
        { id: 11, click() {}, path: "/admin", name: "Admin", icon: "mdi-cog" }
      ],
      moderator: [
        {
          id: 23,
          click() {},
          path: "/moderation",
          name: "Moderation",
          icon: "mdi-gavel"
        }
      ],
      dropdownAuthenticated: [
        { id: 12, click() {}, path: "", name: "Username", disabled: true },
        { id: 13, click() {}, path: "", name: "Username", disabled: false },
        { id: 14, click() {}, path: "", name: "Username", disabled: false },
        { id: 15, click() {}, path: "", name: "Username", disabled: false }
      ],
      default: [
        {
          id: 16,
          click() {},
          path: "/dashboard",
          name: "Login",
          icon: "mdi-login-variant"
        }
      ]
    }
  }),
  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light"
    },
    calculateQuota() {
      return (
        (this.$store.state.user.quota / this.$store.state.user.plan.quotaMax) *
        100
      )
    },
    calculateColorQuota() {
      if (this.calculateQuota >= 80 && this.calculateQuota < 95) {
        return "warning"
      } else if (this.calculateQuota >= 95) {
        return "error"
      } else {
        return "success"
      }
    },
    eligibleMenus() {
      let eligibleMenus = []
      if (this.$store.state.user.username) {
        eligibleMenus.push(...this.menus.authenticated)
      }
      if (
        this.$store.state.site.release === "dev" &&
        this.$store.state.user.username
      ) {
        eligibleMenus.push(...this.menus.debug)
      }
      if (!this.$store.state.user.username) {
        eligibleMenus.push(...this.menus.default)
      }
      return eligibleMenus
    }
  },
  methods: {
    dismissPromoInvite() {
      this.axios.put("/api/v1/userutils/settings/invitesV2Visible", {
        enabled: false
      })
      this.$store.state.user.invitesV2Visible = false
    },
    inviteFriend() {
      this.axios
        .post("/api/v1/userutils/inviteV2/friend", {
          email: this.invite.email
        })
        .then(() => {
          this.$toast.success("Request received.")
          this.invite.email = ""
          this.invite.modal = false
        })
        .catch((e) => {
          AjaxErrorHandler(this.$store)(e)
        })
    },
    goToRoute() {
      if (this.route.value === "forceEnableDevMode") {
        this.$store.state.site.release = "dev"
        localStorage.setItem("forceEnableDevMode", "true")
        this.$toast.success("OK")
        return
      }
      this.$router.push(this.route.value)
      this.route.modal = false
      this.route.value = ""
    },
    handleEnter() {
      if (
        !this.switcher.searchInput &&
        this.$store.state.lastRoute &&
        this.$store.state.lastRoute !== this.$route.path
      ) {
        this.$router.push(this.$store.state.lastRoute)
        this.switcher.dialog = false
      }
    },
    active(path) {
      if (path === this.$route.name) {
        return "#007aff"
      } else {
        return null
      }
    },
    calculateExpired(item) {
      if (!item.active) {
        return true
      } else if (new Date(item.expiredAt).valueOf() < new Date().valueOf()) {
        return true
      } else
        return (
          new Date(item.expiredAt).valueOf() < new Date().valueOf() &&
          !item.active
        )
    },
    getInviteKeys(init) {
      this.axios.get("/api/v1/userutils/list/inviteKeys").then((res) => {
        if (init) {
          this.invite.count = res.data.count
          this.invite.activeCount = res.data.activeCount
          res.data.rows.forEach((invite) => {
            if (invite.invitedUser.length || !this.calculateExpired(invite)) {
              this.invite.keys.push(invite)
            }
          })
        } else {
          this.invite.keys.push(res.data.rows)
          this.invite.count = res.data.count
        }
      })
    },
    fileSize(fileSize) {
      let i = -1
      let byteUnits = ["KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
      do {
        fileSize = fileSize / 1024
        i++
      } while (fileSize > 1024)

      return Math.max(fileSize, 0.1).toFixed(1) + byteUnits[i]
    },
    submitFeedback() {
      this.axios
        .post("/api/v1/feedback/create", {
          text: this.feedback.text,
          starRating: this.feedback.rating,
          route: this.feedback.route
        })
        .then(() => {
          this.feedback.modal = false
        })
        .catch((e) => {
          AjaxErrorHandler(this.$store)(e)
        })
    },
    copyInvite(invite) {
      navigator.clipboard.writeText(
        this.$store.state.site.hostnameWithProtocol +
          "/register?invite=" +
          invite.inviteKey
      )
    },
    inviteUser() {
      this.axios
        .put("/api/v1/userutils/redeem/inviteKey")
        .then((res) => {
          this.invite.key = res.data.inviteKey
          this.axios.get("/api/v1/userutils/info").then((res) => {
            this.$store.commit("login", res.data)
            this.$vuetify.theme.dark = res.data.darkTheme
            this.setAuthMenu()
          })
          this.invite.modal = true
        })
        .catch((e) => {
          AjaxErrorHandler(this.$store)(e)
          this.axios.get("/api/v1/userutils/info").then((res) => {
            this.$store.commit("login", res.data)
            this.$vuetify.theme.dark = res.data.darkTheme
            this.setAuthMenu()
          })
        })
    },
    handleClick(index) {
      this.menus.selected = this.$route.name
      this.menus.authenticated[index].click.call(this)
    },
    handleClickDropdown(index) {
      this.menus.selected = index
      this.menus.dropdownAuthenticated[index].click.call(this)
    },
    logout() {
      this.$store.commit("devLogin", "")
      this.$store.commit("updateToken", "")
      localStorage.removeItem("token")
      localStorage.removeItem("userCache")
      Object.assign(this.axios.defaults, {
        headers: { Authorization: this.$store.state.user.token }
      })
      this.$router.push("/")
    },
    invalidate(key) {
      this.axios
        .put("/api/v1/userutils/invalidate/inviteKey", {
          inviteKey: key.id
        })
        .then(() => {
          this.getInviteKeys(true)
        })
        .catch((e) => {
          this.getInviteKeys(true)
          AjaxErrorHandler(this.$store)(e)
        })
    },
    darkMode() {
      this.$store.commit(
        "setTheme",
        (this.$vuetify.theme.dark = !this.$vuetify.theme.dark)
      )
      this.axios.put("/api/v1/userutils/settings/darkTheme", {
        darkTheme: this.$store.state.user.darkTheme
      })
    },
    provideFeedback() {
      this.feedback = {
        modal: false,
        route: this.$route.path,
        text: "",
        rating: 0
      }
      this.feedback.modal = true
    },
    dayjs(params) {
      return dayjs(params)
    },
    setAuthMenu() {
      if (
        JSON.parse(localStorage.getItem("experiments") ?? "{}")["AUG_2021_UI"]
      )
        return
      this.menus.authenticated = [
        {
          id: 1,
          click() {},
          externalPath: "",
          path: "/dashboard",
          name: "Dashboard",
          icon: "mdi-home"
        },
        {
          id: 2,
          click() {},
          externalPath: "",
          path: "/settings",
          name: "Settings",
          icon: "mdi-account-cog"
        },
        {
          id: 3,
          click() {},
          externalPath: "",
          path: "/domains",
          name: "Domains",
          icon: "mdi-web"
        },
        {
          id: 6,
          click() {},
          externalPath: "",
          path: "/gallery",
          name: "Gallery",
          icon: "mdi-image-multiple"
        },
        {
          id: 26,
          click() {},
          externalPath: "",
          name: "Collections",
          path: "/collections",
          icon: "mdi-folder-multiple-image",
          new: false
        },
        {
          id: 28,
          click() {},
          externalPath: "",
          name: "AutoCollect",
          path: "/autoCollect",
          icon: "mdi-image-auto-adjust",
          new: true,
          warning:
            this.$store.state.user.pendingAutoCollects > 0
              ? this.$store.state.user.pendingAutoCollects
              : false
        },
        {
          id: 27,
          click() {},
          externalPath: "",
          name: "Insights",
          path: "/insights",
          icon: "mdi-chart-timeline-variant-shimmer",
          new: false
        },
        {
          id: 31,
          click() {},
          externalPath: "",
          name: "Starred",
          path: "/starred",
          icon: "mdi-star",
          new: true
        },
        {
          id: 20,
          click() {},
          externalPath: "",
          path: "/users",
          name: "Users",
          icon: "mdi-account-group"
        },
        {
          id: 34,
          externalPath: "https://next.images.flowinity.com",
          path: "",
          name: "Try TPUv2 Beta",
          icon: "mdi-flask",
          gold: true
        },
        {
          id: 29,
          click() {
            this.provideFeedback()
          },
          externalPath: "",
          path: "",
          name: "Provide Feedback",
          icon: "mdi-comment-question-outline"
        },
        {
          id: 30,
          click() {},
          externalPath: "",
          path: "/changelog",
          name: "Changelog & Versions",
          icon: "mdi-history"
        },
        {
          id: 32,
          click() {
            this.invite.modal = true
          },
          externalPath: "",
          path: "",
          name: "Invite a Friend",
          icon: "mdi-gift-outline",
          new: true
        }
        /*{
          id: 9,
          click() {
            this.invite.modal = true
          },
          externalPath: "",
          path: "",
          name: "Invites (" + this.invite.activeCount + ")",
          icon: "mdi-plus"
        },
        {
          id: 22,
          click() {},
          externalPath: "",
          path: "/plans",
          name: "Plans",
          icon: "mdi-star"
        }*/
      ]
      this.menus.brand = [
        {
          id: 21,
          click() {},
          externalPath: "https://discord.gg/ZkCJ7rjrme",
          path: "",
          name: "Discord",
          icon: "mdi-discord"
        }
      ]
      this.menus.dropdownAuthenticated = [
        {
          id: 12,
          click() {},
          path: "/u/" + this.$store.state.user.username,
          name: this.$store.state.user.username,
          disabled: false
        },
        {
          id: 13,
          click() {
            this.darkMode()
          },
          path: "",
          name: "Toggle Theme",
          disabled: false
        },
        {
          id: 15,
          click() {
            this.logout()
          },
          path: "",
          name: "Logout",
          disabled: false
        }
      ]
    },
    getPulseSessionGlobal() {
      const id = Math.random().toString(36).substring(7)
      this.$socket.emit("startPulse", {
        type: "global",
        id,
        action: "focus",
        route: this.$route.path,
        device: navigator.device,
        sysInfo: {
          ua: navigator.userAgent
        },
        name: null,
        other: {
          type: "session"
        }
      })
      this.$socket.on("pulseToken-" + id, (res) => {
        setInterval(() => {
          if (document.hasFocus()) {
            this.pulse.timeOnPageGlobal += 5000
            this.$socket.emit("updatePulse", {
              id: res.id,
              timeOnPage: this.pulse.timeOnPageGlobal
            })
          }
        }, 5000)
      })
    },
    getPulseSession() {
      this.pulse.timeOnPage = 0
      if (
        this.pulse.lastCreated &&
        this.pulse.lastCreated > Date.now() - 1000
      ) {
        return
      }
      this.pulse.lastCreated = Date.now()
      clearInterval(this.pulse.interval)
      this.pulse.timeOnPage = 0
      const id = Math.random().toString(36).substring(7)
      this.$socket.emit("startPulse", {
        type: "global",
        id,
        action: "focus",
        route: this.$route.path,
        device: navigator.device,
        sysInfo: {
          ua: navigator.userAgent
        },
        name: null,
        other: {
          type: "page"
        }
      })
      this.$socket.on("pulseToken-" + id, (res) => {
        this.pulse.id = res.id
        this.pulse.interval = setInterval(() => {
          if (document.hasFocus()) {
            this.pulse.timeOnPage += 5000
            this.$socket.emit("updatePulse", {
              id: res.id,
              timeOnPage: this.pulse.timeOnPage
            })
          }
        }, 5000)
      })
    }
  },
  mounted() {
    this.getPulseSession()
    this.getPulseSessionGlobal()
    this.menus.selected = this.$route.name
    this.$nextTick(() => {
      this.getInviteKeys(true)
      this.setAuthMenu()
    })
    if (this.$vuetify.breakpoint.mobile) {
      this.drawer = false
    }
  },
  watch: {
    group() {
      this.drawer = false
    },
    "$store.state.user.pendingAutoCollects"() {
      this.setAuthMenu()
    },
    $route(to, from) {
      this.getPulseSession()
      this.$store.state.lastRoute = from.path
      this.$socket.emit("pulse", {
        action: "page-change",
        route: to.path,
        timeSpent: 0,
        device: navigator.device,
        sysInfo: {
          ua: navigator.userAgent
        },
        name: null,
        other: {
          lastRoute: from.path
        }
      })
      this.axios.get("/api/v1/userutils/info").then((res) => {
        this.$store.commit("login", res.data)
        if (res.data.subscription) {
          this.$store.commit("setSubscription", res.data)
        }
        this.$vuetify.theme.dark = res.data.darkTheme
        this.setAuthMenu()
      })
    },
    "switcher.search"() {
      if (this.switcher.search) {
        this.$router.push(this.switcher.search.route)
        this.switcher.dialog = false
        this.switcher.search = null
        this.$nextTick(() => {
          this.switcher.searchInput = null
        })
      }
    }
  }
}
</script>
